import {
  AddressCollectionSchema,
  AddressType,
} from "@redotech/redo-model/address-collection";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getAddressCollections = {
  name: "getAddressCollections" as const,
  input: z.object({ type: createEnum(AddressType).optional() }),
  output: z.object({ addresses: z.array(AddressCollectionSchema) }),
};
